export var dictonary = {
  error: {
    EMPTY: 'Поле не может быть пустым',
    PASSWORD: 'Не верное значение пароля',
    RETRY: 'Пароли не совпадают',
    VALIDATION: 'Не корректно введены e-mail или пароль',
    INCORRECT: 'Такого E-mail не существует или не верно введён пароль',
    REGISTRATION: 'Публичная регистрация отключена',
    PHONE_INCORRECT: 'Не верный формат телефона',
    PARTNER_NOT_FOUND: 'Данный номер не зарегистрирован, обратитесь к Администратору',
    CODE_INCORRECT: 'Не верное значение кода'
  },
  title: {
    signUp: 'Регистрация',
    login: 'Вход'
  },
  formControl: {
    email: {
      label: 'E-mail',
      placeholder: 'Введите email'
    },
    password: {
      label: 'Пароль',
      placeholder: 'Введите пароль'
    },
    passwordRetry: {
      label: 'Подтверждение пароля',
      placeholder: 'Введите подтверждение пароля'
    },
    isRememberMe: {
      placeholder: 'Запомнить меня'
    },
    phone: {
      label: 'Номер телефона',
      placeholder: 'Введите номер телефона'
    },
    code: {
      label: 'Код',
      placeholder: 'Введите код из смс'
    }
  },
  button: {
    signUp: 'Зарегистрироваться и войти',
    sendPhone: 'Отправить код на телефон',
    getToken: 'Войти'
  },
  mutedText: {
    signUp: {
      label: 'Уже зарегистрированны? ',
      link: 'авторизоваться'
    },
    login: {
      label: 'Для новых пользователей ',
      link: 'регистрация'
    }
  }
};